import CompanySizeIcon from './CompanySize'
import LocationIcon from './Location'
import EducationIcon from './Education'
import PhoneNumberIcon from './PhoneNumber'
import CalendarIOS16GlyphICon from './CalendarIOS16Glyph'
import AdminIcon from './Admin'
import HeadHunterIcon from './HeadHunter'
import AddressIcon from './Address'
import SalaryIcon from './Salary'
import GenderIcon from './Gender'
import TranslatorIcon from './Translator'
import BirthdayIcon from './Birthday'
import LocationIOS16GlyphIcon from './LocationIOS16Glyph'
import CreditIcon from './CreditIcon'

const InfoOverview = {
    CompanySizeIcon,
    LocationIcon,
    EducationIcon,
    PhoneNumberIcon,
    CalendarIOS16GlyphICon,
    AdminIcon,
    HeadHunterIcon,
    SalaryIcon,
    AddressIcon,
    GenderIcon,
    TranslatorIcon,
    BirthdayIcon,
    LocationIOS16GlyphIcon,
    CreditIcon
}
export default InfoOverview
